import { Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../abstract.component';

export interface TagTextData {
  text: string;
  tag?: string;
  color?: string;
  text_shadow?: string;
  font_size?: string;
  bold?: boolean;
}

@Component({
  selector: 'tag-text',
  template: `
    <ng-container *ngIf="data && data.text" [ngSwitch]="data.tag">
      <h1 *ngSwitchCase="'H1'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-{{screenType === 'MOBILE'? 'h2' : 'h1'}} tag-text-heading" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h1>

      <h2 *ngSwitchCase="'H2'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-{{screenType === 'MOBILE'? 'h3' : 'h2'}} tag-text-heading" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h2>

      <h3 *ngSwitchCase="'H3'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}" \
        class="eva-3-{{screenType === 'MOBILE'? 'h4' : 'h3'}} tag-text-heading" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h3>

      <h4 *ngSwitchCase="'H4'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-{{screenType === 'MOBILE'? 'h5' : 'h4'}} tag-text-heading" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h4>

      <h5 *ngSwitchCase="'H5'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-{{screenType === 'MOBILE'? 'h6' : 'h5'}} tag-text-heading" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h5>

      <h6 *ngSwitchCase="'H6'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-h6" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h6>

      <h6 *ngSwitchCase="'B1'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-body-1" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h6>

      <h6 *ngSwitchCase="'B2'" [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-body-2" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></h6>

      <p *ngSwitchDefault [ngStyle]="{'color': data.color, 'text-shadow': data.text_shadow, 'font-size': data.font_size}"
        class="eva-3-body-1" [ngClass]="{'-eva-3-bold': data.bold}" [innerHTML]="data.text | replaceKeywords: keywordsMap | tagTextUnescape"></p>
    </ng-container>
  `,
  styleUrls: ['tag-text.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TagTextComponent extends AbstractComponent {
  @Input() data?: TagTextData;

  constructor(injector: Injector) {
    super(injector);
  }

  getModuleId() {
    return "TagTextComponent";
  }
}
